import ReactDOM from 'react-dom/client';
import './index.css';
import './theme/styles/bootstrap.css'
import './theme/styles/style.css'
import './assets/fonts/css/fontawesome-all.min.css'
import './theme/scss/style.scss'
import './styles/custom.css'
import './styles/auth.css'
import './styles/campaign.css'
import { Provider } from 'react-redux';
import { persistor, store } from './redux-stores/store';
import App from './App';
import { PersistGate } from 'redux-persist/integration/react';
import { ToastContainer } from 'react-toastify';
import 'react-loading-skeleton/dist/skeleton.css'
import * as Sentry from "@sentry/react";
import { APP_ENV, SENTRY_URL } from './constants/constants';
import { FirebaseProvider } from './contexts/FirebaseContext';
import { BrowserRouter } from 'react-router-dom';

const referrer = (new URLSearchParams(window.location.search)).get('referrer');
if (referrer) {
    window.localStorage.setItem("_tt_referrer", referrer);
}

if(APP_ENV === 'production'){
    Sentry.init({
        dsn: SENTRY_URL,
        integrations: [],
    });
}

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    // <React.StrictMode>
    <Provider store={store}>
        <PersistGate loading={<div>Loading...</div>} persistor={persistor}>
            <FirebaseProvider>
                <BrowserRouter>
                  <App />
                </BrowserRouter>
            </FirebaseProvider>
            <ToastContainer position='bottom-center' theme='colored' autoClose={2000} />
        </PersistGate>
    </Provider>
    // </React.StrictMode>
);